const DurationType = {
  Daily: "DAILY",
  Weekly: "WEEKLY",
  Monthly: "MONTHLY",
  NoContract: "NO_CONTRACT",
} as const;

Object.setPrototypeOf(DurationType, {
  format(
    durationType: (typeof DurationType)[keyof typeof DurationType],
    isPlural = false,
  ) {
    let text: string = durationTypeToInterval[durationType];
    if (!isPlural && text[text.length - 1] === "s") {
      text = text.substring(0, text.length - 1);
    }

    return text;
  },
});

const durationTypeToInterval = {
  [DurationType.Daily]: "days",
  [DurationType.Weekly]: "weeks",
  [DurationType.Monthly]: "months",
  [DurationType.NoContract]: "no contract",
} as const;

export default DurationType;
